<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Poçt rabitəsi xidmətləri</h1>
      </div>
      
      <div class="col-12">
        <h2>Ölkədaxili</h2>
        <p>“Azərpoçt” MMC tərəfindən Azərbaycan Respublikası ərazisində qəbul edilən, göndərilən və çatdırılan poçt göndərişləri üzrə tariflər:</p>
      </div>

      <div class="col-md-6">

        <p>Göndərişin növü:</p>
        <select v-model="type" @change="calcPrice">
          <option value="letter">Məktub</option>
          <option value="wrapper">Banderol</option>
          <option value="parcel">Bağlama</option>
        </select>

        <p>Çəkisi (qr):</p>
        <input type="number" v-model.number="weight" @input="calcPrice">
        
        <div class="d-flex align-items-center justify-content-between" v-if="isRegister">
          <p>Sifarişli?</p>
          <div class="d-flex align-items-center">
            <label class="checkbox-wrapper">Xeyr
              <input type="radio" value="no" v-model="registered" @change="calcPrice">
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">Bəli
              <input type="radio" value="yes" v-model="registered" @change="calcPrice">
              <span class="checkmark"></span>
            </label>
          </div>
        </div>

        <p>Qiymət (AZN):</p>
        <input type="text" v-model="price" disabled>

      </div>

      <div class="col-md-6">
        <div class="note">
          <p>Sadə və sifarişli məktublarda yazışmalar, işgüzar sənədlər, şəkillər, bədii açıqcalar, reklam-məlumat çap materialları, sxemlər və əlyazmalar göndərilir.</p>
          <p>Sadə və sifarişli banderollarda yalnız kütləvi tirajlı çap məhsulları (blanklar, broşürlər, plakatlar), dövrü çap nəşrləri, bədii və digər ədəbiyyat göndərilir.</p>
          <p>Bağlamalarda mədəni-məişət və istehsal təyinatlı əşyalar, uzun müddət saxlanıla bilən qida məhsulları, bitkilər, çap məhsulları, dərman preparatları, meyvə, tərəvəz və sair əşyalar göndərilir.</p>
        </div>
      </div>

      <div class="col-12">
        <h2>Beynəlxalq</h2>
        <p>Beynəlxalq poçt göndərişləri (bağlamalar) üçün müəyyən edilmiş tariflər:</p>
      </div>

      <div class="col-md-6">
        <p>Təyinat ölkəsi:</p>
        <select v-model="intCountry" @change="calcIntPrice">
          <option v-for="item in int" :value="item.country">{{ item.country }}</option>
        </select>

        <p>Daşınma üsulu:</p>
        <select v-model="intType" @change="calcIntPrice">
          <option value="standart">Yerüstü</option>
          <option value="priority">Avia</option>
        </select>

        <p>Çəkisi (qr):</p>
        <input type="number" v-model.number="intWeight" @input="calcIntPrice">

        <p>Qiymət (AZN):</p>
        <input type="text" v-model="intPrice" disabled>

      </div>

      <div class="col-md-6">
        <div class="note">
          <p>Beynəlxalq bağlamalarda mədəni-məişət və istehsal təyinatlı əşyalar, uzun müddət saxlanıla bilən qida məhsulları, çap məhsulları, bitkilər, dərman vasitələri, eləcə də təyinat ölkəsinə idxalına icazə verilmiş və qanunvericiliklə qadağan olunmamış digər əşya və mallar göndərilir.</p>
        </div>
      </div>
      <div class="col-12">
        <div class="note">
          <p>Daxil olan beynəlxalq göndərişin gömrük nəzarətinə təqdim edilməsi:</p>
          <ul>
            <li>qiyməti bəyan olunmuş göndəriş, kiçik paket və M kisənin hər biri üçün - 1,40 AZN</li>
            <li>bağlamanın hər biri üçün - 2,00 AZN</li>
          </ul>
        </div>
        <div class="note">
          <p>Fiziki şəxslər tərəfindən təyinatı istehsal, yaxud kommersiya məqsədləri üçün nəzərdə tutulmayan hesab edilmiş aşağıda göstərilən mallar güzəştli qaydada (gömrük ödənişlərini ödəmədən) Azərbaycan Respublikasının gömrük sərhədindən keçirilə bilər:</p>
          <ul>
            <li>beynəlxalq poçt göndərişləri və ya daşıyıcı şirkət vasitəsilə eyni fiziki şəxsin adına 30 (otuz) gün müddətində ümumi gömrük dəyəri 1000 ABŞ dolları ekvivalenti məbləğindən artıq olmayan gömrük ərazisinə gətirilən mallar;</li>
            <li>poçt göndərişləri və ya daşıyıcı şirkət vasitəsilə gömrük ərazisindən göndərilən mallar.</li>
          </ul>
        </div>
      </div>

      <div class="col-12">

        <h2>Bakı şəhəri və Azərbaycan ərazisi üçün poçt indeksləri:</h2>
        <input type="text" v-model="query" placeholder="Ərazini daxil edin" @input="getIndeks(query)">
        
        <div class="spinner" v-if="loading"><div></div><div></div><div></div></div>
        
        <table v-if="indeks.length > 0">
          <thead>
            <tr>
              <th>Ərazi</th>
              <th>İndeks</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in indeks">
              <td>{{ item.name }}</td>
              <td>{{ item.indeks }}</td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>
</template>

<script>

  import axios from 'axios'

  export default {
    data(){
      return {
        type: 'letter',
        weight: '',
        registered: 'no',
        price: 0,
        int: [],
        intCountry: 'ABŞ',
        intType: 'standart',
        intWeight: '',
        intPrice: 0,
        loading: false,
        indeks: '',
        query: ''
      }
    },
    mounted(){
      axios
        .get('inc/azerpost.json')
        .then(response => {
            this.int = response.data;
          });
    },
    methods: {
      calcPrice: function(){

        if(this.type == 'parcel'){
          this.price = (1.8 + Math.ceil(this.weight/1000) * 0.4).toFixed(2);
        } else {
          
          switch (true) {
            case (this.weight <= 20):
              this.price = 0.20
              break;
            case (this.weight <= 50):
              this.price = 0.30
              break;
            case (this.weight <= 100):
              this.price = 0.50
              break;
            case (this.weight <= 250):
              this.price = 0.80
              break;
            case (this.weight <= 500):
              this.price = 1.10
              break;
            case (this.weight <= 1000):
              this.price = 1.40
              break;
            case (this.weight <= 2000):
              this.price = 1.80
              break;
            default:
              this.price = 0
              break;
          }

          if(this.registered === 'yes') {
            this.price += 0.30
          }

          this.price = (this.price).toFixed(2)
        }

      },
      calcIntPrice: function(){
        let self = this;
        let arr = self.int.filter(function(item) {
          return item.country === self.intCountry;
        });
        this.intPrice = +arr[0][this.intType][0] + (this.intWeight * arr[0][this.intType][1] / 1000);
        this.intPrice = this.intPrice.toFixed(2);
      },
      getIndeks: function(query){
        this.loading = true;
        axios.get('inc/post.php', {
            params: {
              query: this.query
            }
          })
          .then(response => {
            this.loading = false;
            this.indeks = response.data;
          })
          .catch(error => {
            this.loading = true;
            console.log(error);
          });
        }
    },
    computed: {
      isRegister: function(){
        if(this.type === 'parcel'){
          return false
        } else {
          return true
        }
      }
    }
  }
</script>

<style scoped>

.note ul {
  padding: 0 1rem;
}
table thead tr th:first-child,
table tbody tr td:first-child {
  text-align: left;
}
.checkbox-wrapper {
  display: block;
  position: relative;
  padding-left: 2rem;
  margin-right: 1rem;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.checkbox-wrapper input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkbox-wrapper .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #ccc;
  border-radius: 100%;
}
.checkbox-wrapper:hover input ~ .checkmark {
  background-color: #ccc;
}
.checkbox-wrapper input:checked ~ .checkmark {
  background-color: #003366;
}
  
</style>


// WEBPACK FOOTER //
// src/components/calc/Post.vue